<template>
    
    <div class="scroll" ref="scroll">
        <ul class="content d_f">
            <li class="scroll-item bg_grey" v-for="(item) in list" :key="item.id">
                <router-link :to="postMain?'/':'/product/details?id='+item.id" class="d_b h_1 w_1">
                    <img :src="item.photoUrl" alt="">
                    <p class="c_black">{{item.productName}}</p>
                </router-link>
            </li>
        </ul>
    </div>
</template>

// '/product/details?id='+item.id

<script>

import BScroll from 'better-scroll'
import product from '../../api/product'
export default {

    props : {
        list : {
            type : Array ,
            default : function(){
                return []
            }
        },
        postMain : {
            type : Boolean ,
            default : false
        }
    },
    data(){
        return {
            products : []
        }
    },

    created(){
        product.getHomeProducts({
            num : 5,
            corpId : '1260178594865426434'
        }).then(res=>{
            this.products = res;
        });
    },


    mounted() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs.scroll, {
            scrollX : true,
            click: true,
            bounce : true
        })
      })
    },
}


</script>

<style lang='scss' scoped>

    .scroll{
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .content{
            height: 100%;
            width: 1665px;
            .scroll-item{
                width: 308px;
                height: 406px;
                margin-right: 25px;
                a{
                    padding: 30px 30px 0;
                    img{
                        display: block;
                        width: 248px;
                        height: 272px;
                    }
                    p{
                        text-align: center;
                        margin:0;
                        line-height: 104px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 750px) {


        .scroll{
            .content{
                height: 100%;
                width: 168.883vw;
                .scroll-item{
                    width: 33.777vw;
                    height: 100%;
                    margin-right: 0;
                    a{
                        padding: 5.319vw 5.319vw 0;
                        img{
                            display: block;
                            width: 23.138vw;
                            height: 25.266vw;
                        }
                            p{
                                text-align: center;
                                padding: 0 1.33vw;
                                margin:0;
                                line-height:5.319vw;
                                height: 10.638vw;
                                font-size: 3.458vw;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                }
            }




    }


</style>